import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';

import css from './SectionTextBlock.module.css';

/**
 * Centered prose block: title + paragraph, with an optional inline trailing
 * link (e.g. the Mission section's partnersinfoodsolutions.com reference).
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string} props.sectionId
 * @param {'textBlock'} props.sectionType
 * @param {Object?} props.title title (Field data)
 * @param {Object?} props.text paragraph (Field data)
 * @param {Object?} props.link { content, href } appended inline after the text
 * @param {Object?} props.appearance
 * @param {Object} props.options
 * @returns {JSX.Element}
 */
const SectionTextBlock = props => {
  const {
    sectionId,
    className,
    rootClassName,
    title,
    text,
    link,
    appearance,
    options,
  } = props;

  const fieldOptions = { fieldComponents: options?.fieldComponents };
  const hasContent = hasDataInFields([title, text], fieldOptions);
  if (!hasContent) return null;

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(rootClassName || css.root, className)}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.content}>
        <Field data={title} className={css.title} options={fieldOptions} />
        <div className={css.body}>
          <Field data={text} className={css.text} options={fieldOptions} />
          {link?.content && link?.href ? (
            <a className={css.link} href={link.href} target="_blank" rel="noopener noreferrer">
              {link.content}
            </a>
          ) : null}
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionTextBlock;
